import { useMemo } from "react";

import type * as Type from "../type";

type Props = {
	optionPmsOptionListServerData: Type.ServerData.OptionPmsOptionListServerData | undefined;
};
type Result = {
	optionPmsOptionListQueryData: Type.QueryData.OptionPmsOptionListQueryData;
};

export const useOptionPmsOptionListConverter = ({ optionPmsOptionListServerData }: Props): Result | undefined => {
	/**
	 * QueryData への変換処理
	 */
	return useMemo((): Result | undefined => {
		if (!optionPmsOptionListServerData) return undefined;

		return {
			optionPmsOptionListQueryData: {
				optionPmsOptionList: {
					id: optionPmsOptionListServerData.optionPmsOptionList.id,
					options: optionPmsOptionListServerData.optionPmsOptionList.options.map(({ optionID, name }) => ({
						optionID,
						name,
					})),
				},
			},
		} satisfies Result;
	}, [optionPmsOptionListServerData]);
};
